import React, { useState, useEffect } from "react";
import "../styles/Users.scss";
import {
  getAllClients,
  deleteClient,
} from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import ExcelJS from "exceljs";
import Swal from "sweetalert2";
import { FaEdit, FaTrash } from "react-icons/fa";

const ITEMS_PER_PAGE = 10;

function Clients() {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const fetchData = async () => {
    Swal.fire({
      html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
      showConfirmButton: false,
      heightAuto: false,
      customClass: { popup: "loader-swal" },
      allowOutsideClick: false,
    });
    let apiData = await getAllClients();
    Swal.close();
    if (
      apiData &&
      (apiData.status === "S" || apiData.result_code === 200) &&
      apiData.result_info
    ) {
      const formattedClients = apiData.result_info.map((client) => ({
        ...client,
      }));
      setClients(formattedClients);
    } else {
      setClients([]);
    }
    if (
      apiData.status === "F" &&
      (apiData.message === "Unauthorized - Missing token" ||
        apiData.message === "Unauthorized - Invalid token")
    ) {
      Swal.fire({
        text: "Please login with your credentials",
        icon: "warning",
        showConfirmButton: false,
        timer: 3000,
      }).then(() => {
        localStorage.clear();
        navigate("/login");
      });
    }
  };


   

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [navigate]);

  const handleDelete = async (id) => {
    const client = clients.find((u) => u.id === id);
    Swal.fire({
      title: `Delete client?`,
      text: `Are you sure you want to delete ${client?.name || "this client"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteClient(id);
          setClients(clients.filter((u) => u.id !== id));
          Swal.fire("Deleted!", "Client has been deleted.", "success");
          fetchData();
        } catch (err) {
          Swal.fire("Error", "Failed to delete client.", "error");
        }
      }
    });
  };

  const filteredClients = clients.filter((u) => {
    const q = search.toLowerCase();
    const matchesText =
      (u.name && u.name.toLowerCase().includes(q)) ||
      (u.city && u.city.toLowerCase().includes(q));

    return matchesText;
  });

  const pageCount = Math.ceil(filteredClients.length / ITEMS_PER_PAGE);
  const paginatedClients = filteredClients.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const handleEdit = (id) => {
    navigate(`/clients/edit/${id}`);
  };

  // Helper to format date as dd-mm-yyyy
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d)) return "-";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Including format date with time zone
  //   const formatDate = (dateStr) => {
  //   if (!dateStr) return "-";

  //   const date = new Date(dateStr);
  //   if (isNaN(date)) return "-";

  //   const formatter = new Intl.DateTimeFormat("en-IN", {
  //     timeZone: "Asia/Kolkata",
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //   });

  //   const parts = formatter.formatToParts(date);
  //   const day = parts.find(p => p.type === "day")?.value;
  //   const month = parts.find(p => p.type === "month")?.value;
  //   const year = parts.find(p => p.type === "year")?.value;

  //   return `${day}-${month}-${year}`;
  // };

  // Reset to page 1 on filter change

  useEffect(() => {
    setPage(1);
  }, [search, clients.length]);

  const handleExport = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Clients");
  
      // Add header row
      worksheet.columns = [
        { header: "Name", key: "name" },
        { header: "Website", key: "website" },
        { header: "City", key: "city" },
        { header: "Country", key: "country" },
        { header: "Created Date", key: "created_date" },
        { header: "Updated Date", key: "updated_date" },
      ];
  
      // Add data rows
      clients.forEach((item) => {
        worksheet.addRow({
          name: item.name || "-",
          website: item.website || "-",
          city: item.city || "-",
          country: item.country || "-",
          created_date: formatDate(item.created_at) || "-",
          updated_date: formatDate(item.updated_at) || "-",
        });
      });
  
      // Create a Blob from the workbook
      const buffer = await workbook.xlsx.writeBuffer();
  
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      // Trigger download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Clients.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    };

    
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pageCount) return;
    setPage(newPage);
  };

    function getPageNumbers(currentPage, totalPages, maxPagesToShow = 5) {
    const pages = [];

    const half = Math.floor(maxPagesToShow / 2);
    let start = Math.max(currentPage - half, 1);
    let end = start + maxPagesToShow - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - maxPagesToShow + 1, 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  return (
    <div className="requisitions-page">
      <div className="requisitions-header-row">
        <div className="requisitions-title-group">
          <h1>Clients</h1>
        </div>
        <button className="export-btn" onClick={handleExport}>
          Export
        </button>
        
      </div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          marginBottom: "1.5rem",
          alignItems: "center",
          justifyContent: 'space-between'
        }}
      >
        <input
          type="text"
          placeholder="Search by Name and City"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            minWidth: 260,
            maxWidth: 300,
            padding: "0.4rem .5rem",
            border: "1.5px solid #d1d5db",
            borderRadius: 6,
            background: "#fff",
            fontSize: "1rem",
          }}
                    
          className="custom-placeholder"
        />
        <Link to="/clients/create" className="create-btn">
          Create Client
        </Link>
      </div>
      <div className="requisitions-table-wrapper">
        <table className="requisitions-table clients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Website</th>
              <th>City</th>
              <th>Country</th>
              <th>Created Date</th>
              <th>Updated Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedClients.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  No clients found.
                </td>
              </tr>
            ) : (
              paginatedClients.map((client) => (
                <tr key={client.id}>
                  <td title={client.name}>{client.name}</td>
                  <td title={client.website}>{client.website}</td>
                  <td title={client.city}>{client.city}</td>
                  <td title={client.country}>{client.country}</td>
                  <td title={formatDate(client.created_at)}>{formatDate(client.created_at)}</td>
                  <td title={formatDate(client.updated_at)}>{formatDate(client.updated_at)}</td>
                  <td>
                    <div className="d-flex align-items-center">
<button
                      className="icon-btn"
                      onClick={() => handleEdit(client.id)}
                      title="Edit"
                      style={{
                        color: "#0078b9",
                        background: "none",
                        border: "none",
                        marginRight: 8,
                      }}
                    >
                      <FaEdit size={20} />
                    </button>

                    <button
                      className="icon-btn"
                      onClick={() => handleDelete(client.id)}
                      title="Delete"
                      style={{
                        color: "#e53e3e",
                        background: "none",
                        border: "none",
                      }}
                    >
                      <FaTrash size={20} />
                    </button>
                    </div>
                    
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      {pageCount > 1 && (
  <div className="settings-pagination">
    <button
      className="pagination-btn"
      onClick={() => handlePageChange(page - 1)}
      disabled={page === 1}
    >
      &lt;
    </button>
    {getPageNumbers(page, pageCount, 5).map((pageNum) => (
      <button
        key={pageNum}
        className={"pagination-btn" + (page === pageNum ? " active" : "")}
        onClick={() => handlePageChange(pageNum)}
      >
        {pageNum}
      </button>
    ))}
    <button
      className="pagination-btn"
      onClick={() => handlePageChange(page + 1)}
      disabled={page === pageCount}
    >
      &gt;
    </button>
  </div>
)}
    </div>
  );
}

export default Clients;
